import { CHANNEL, STOCK_STATUS } from 'config'
import { KeyValuePairOfStringAndString } from './graphql/graphql'

export const getStockAvailability = (
  channel: CHANNEL,
  metadata?: KeyValuePairOfStringAndString[],
): STOCK_STATUS | null => {
  if (!metadata) return null
  switch (channel) {
    case CHANNEL.NORTH_AMERICA:
      return null
    default: {
      const stockState = metadata.find((m) => m.key === 'DSV_StockState')?.value
      return Object.values(STOCK_STATUS).includes(stockState as STOCK_STATUS)
        ? (stockState as STOCK_STATUS)
        : null
    }
  }
}
